import { MHTTPCL, JSON_STRING, HttpClient } from "../../../services/http/http-client";
import { SETTINGS_URL } from "../../../services/common-urls";
import { LABEL_URL } from "../../accounting/services/costs.service";

export const LabelSettingsService = {
  findLabelSettings: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    output: JSON_STRING,
  }),
  findLabelSettings2: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'label_setting',
    output: JSON_STRING,
  }),
  findLicenseSettings: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'label_licencing_setting',
    output: JSON_STRING,
  }),
  findAdditionalInfo: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'init_label_setting_additional_info_tab',
  }),
  findLabelStatuses: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'get_label_statuses',
  }),

  // Label Status APIs
  findLabelStatusDetails: ({ label_status_id }) => HttpClient.post(SETTINGS_URL, {
    section: "labelsettings",
    action: "open_add_edit_label_status_modal",
    label_status_id,
  }),
  createUpdateLabelStatus: ({
    label_status_name,
    external_table,
    label_status_colour,
    default_status_flag,
    inactive_flag,
    label_status_id,
  }) => HttpClient.post(SETTINGS_URL, {
    section: "labelsettings",
    action: "add_edit_label_status",

    label_status_name,
    external_table,
    label_status_colour,
    default_status_flag,
    inactive_flag,
    label_status_id,
  }),
  deleteLabelStatus: (label_status_id) => {
    return HttpClient.post(SETTINGS_URL, {
      section: "labelsettings",
      action: "delete_label_status",
      label_status_id,
    });
  },

  // Shipping Types API
  createUpdateShippingType: ({
    shipping_type_id,
    shipping_type,
    service_code,
  }) => {
    return HttpClient.post(SETTINGS_URL, {
      section: "labelsettings",
      action: "add_edit_shipping_type",
      shipping_type_id,
      shipping_type,
      service_code,
    });
  },
  findShippingTypes: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'get_shipping_types',
  }),
  deleteShippingType: (shipping_type_id) => {
    return HttpClient.post(SETTINGS_URL, {
      section: "labelsettings",
      action: "delete_shipping_type",
      shipping_type_id,
    });
  },


  findInitLicensingSettings: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'init_label_licencing_setting',
  }),
  findRoyaltyDealTypes: () => HttpClient.post(LABEL_URL, {
    section: 'royalty',
    action: 'deal_types',
  }),

  // Mechanical Settings API
  findMechanical: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'mechanical_rates_home',
    output: JSON_STRING,
  }),
  createMechanical: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'mechanical_rates_add',
    output: JSON_STRING,
  }),
  removeMechanical: (mechanical_rate_id) => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'mechanical_rates_remove',
    mechanical_rate_id,
    output: JSON_STRING,
  }),


  findAdvanceTypes: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'get_advance_types',
    output: JSON_STRING,
  }),

  findFormatDetails: ({
    format_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'edit_format_form',
    output: JSON_STRING,
    format_id,
  }),

  // Product Type APIS
  findProductTypeDetails: ({
    product_type_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'edit_product_type_form',
    output: JSON_STRING,
    product_type_id,
  }),

  //Price List APIS
  findPriceListDetails: ({
    price_list_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'edit_price_list_form',
    output: JSON_STRING,
    price_list_id,
  }),
  findAddPriceListDetails: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'add_price_list_form',
    output: JSON_STRING,
  }),


  // Media Type API
  findEditMediaDetails: ({
    media_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'edit_media_form',
    output: JSON_STRING,
    media_id
  }),

  //Price Code API
  findEditPriceCode: ({
    price_code_id
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'edit_price_code_form',
    output: JSON_STRING,
    price_code_id,
  }),
  findAddPriceCode: () => HttpClient.post(SETTINGS_URL, {
    section: 'labelsettings',
    action: 'add_price_code_form',
    output: JSON_STRING,
  }),

  // API Keys
  findSharingData: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'sharing',
    output: JSON_STRING,
  }),
}